import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { CheckboxField } from "../../../../../../features/forms/fields/checkbox-field/checkbox-field.component";
import { IS_REGIONAL } from "../../../../../../features/new-execution-briefs/constants";
import { SelectField } from "../../../../../../features/forms/fields/select-field/select-field.component";
import { getRegionOptions } from "../../../../../../redux/actions/executionBriefListActions";
import { selectRegionResults } from "../../../../../../redux/selectors/commonSelectors";

import { CbTemplateControlRegionsProps } from "./cb-template-control-regions.props";

export const CbTemplateControlRegions = (props: CbTemplateControlRegionsProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRegionOptions());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const regionsList = useSelector(selectRegionResults);
  const regionsOptions = regionsList.map((region) => ({
    value: region.id,
    label: region.name,
  }));

  return (
    <BorderedBlock bordersOff={props.bordersOff}>
      <CheckboxField
        form={props.form}
        label={IS_REGIONAL.TITLE}
        name={IS_REGIONAL.ID}
        userPermissions={props.userPermissions}
      >
        <SelectField
          form={props.form}
          label="Regions"
          multiple
          name="regions"
          options={regionsOptions}
          placeholder="Select Region"
          userPermissions={props.userPermissions}
        />
      </CheckboxField>
    </BorderedBlock>
  );
};
